import { put, call, all, fork, select, takeLatest, actionChannel } from "redux-saga/effects";
import {
  sectorsApiUpsellProvider,
  usersApiUpsellProvider,
  pdcsApiUpsellProvider,
  sectorApiUpsellProvider
} from "../../lib/api/providers";

import {
  SECTORS_SET_PAGINATION,
  SECTORS_SET_LIST,
  SECTORS_GET_MANAGER_USERS_LIST,
  SECTORS_SET_MANAGER_USERS_LIST,
  SECTORS_SET_PDCS,
  SECTORS_GET_PDCS,
  SECTORS_ADD_PDC,
  SECTORS_REMOVE_PDC,
  SECTORS_SET_ALL
} from "../types";
import _ from "lodash";
import { currentClientSelector } from "../selectors/auth";

const getState = state => state;
const getSectorsState = state => state.sectors || {};

const getSectorsApi = (state, sectorsState, action) => {
  return sectorsApiUpsellProvider
    .post(`/`, {
      match: { client_id: state.currentClient.id },
      page: sectorsState.page > 0 ? action.page : 1,
      pageSize: sectorsState.pageSize
    })
    .then((response = {}) => {
      return response.data;
    });
};

const getPDCSApis = () => {
  return pdcsApiUpsellProvider
    .post(`/`, {
      project: {
        pdc_label: 1,
        pdc_id: 1,
        cp: "$adresse.cp",
        regionales: "$centrales.regionale.nom",
        retailer_id: "$retailer_id",
        _id: 0
      }
    })
    .then((response = {}) => {
      return response.data;
    });
};

const addPDCApi = (state, sector_id, pdc_id, client_id) => {
  const token = state.auth.token;
  return sectorApiUpsellProvider
    .post(
      `/${sector_id}/addPDC`,
      {
        pdc_id: pdc_id,
        client_id
      },
      {
        headers: {
          Authorization: token
        }
      }
    )
    .then((response = {}) => {
      return response.data;
    });
};
const removePDCApi = (state, sector_id, pdc_id, client_id) => {
  const token = state.auth.token;
  return sectorApiUpsellProvider
    .post(
      `/${sector_id}/removePDC`,
      {
        pdc_id: pdc_id,
        client_id
      },
      {
        headers: {
          Authorization: token
        }
      }
    )
    .then((response = {}) => {
      return response.data;
    });
};

const getManagerUsersListApi = state => {
  const token = state.auth.token;
  const roleId = state.userInfos.role_id;
  const clientId = state.currentClient.label;

  return usersApiUpsellProvider
    .post(
      `/`,
      {
        match: {
          "clients.label": clientId,
          role_id: { $gte: roleId }
        }
      },
      {
        headers: {
          Authorization: token
        }
      }
    )
    .then((response = {}) => {
      return response.data;
    });
};

function* getSectorsList(action) {
  try {
    const state = yield select(getState);
    const sectorsState = yield select(getSectorsState);
    const data = yield call(getSectorsApi, state, sectorsState, action);
    if (!Array.isArray(data.docs)) throw new Error("Aucun secteur trouvé.");

    yield put({ type: SECTORS_SET_LIST, payload: data });
  } catch (e) {
    console.log(e.message);
  }
}

function* getManagerUsersList() {
  try {
    const state = yield select(getState);
    const data = yield call(getManagerUsersListApi, state);

    yield put({ type: SECTORS_SET_MANAGER_USERS_LIST, payload: data });
  } catch (e) {
    console.log(e.message);
  }
}

function* getPDCS() {
  try {
    const sectors = yield select(getSectorsState);
    const pdcs = sectors.pdcs || [];
    if (pdcs.length > 0) return;
    const data = yield call(getPDCSApis);

    yield put({ type: SECTORS_SET_PDCS, pdcs: data });
  } catch (e) {
    console.log(e.message);
  }
}

function* addPDC(action) {
  try {
    const state = yield select(getState);
    const pdcs = state.sectors.pdcs || [];
    const sectors = yield select(getSectorsState);
    const sectorsList = sectors.sectorsList || [];
    const sector = _.find(sectorsList, {
      sector_id: parseInt(action.sector_id)
    });
    const pdc = _.find(pdcs, { pdc_id: parseInt(action.pdc_id) });
    if (!sector || !pdc) return;
    sector.salepoints = sector.salepoints || [];
    sector.salepoints.unshift(pdc);
    sector.salepoints = _.uniqBy(sector.salepoints, "pdc_id");
    yield put({ type: SECTORS_SET_ALL, sectorsList: _.cloneDeep(sectorsList) });
    const currentClient = yield select(currentClientSelector);
    yield call(addPDCApi, state, action.sector_id, action.pdc_id, currentClient.id);
  } catch (e) {
    console.log(e.message);
  }
}

function* removePDC(action) {
  try {
    const state = yield select(getState);
    const sectors = yield select(getSectorsState);
    const sectorsList = sectors.sectorsList || [];
    const sector = _.find(sectorsList, {
      sector_id: parseInt(action.sector_id)
    });

    if (!sector) return;
    sector.salepoints = sector.salepoints || [];
    _.remove(sector.salepoints, { pdc_id: action.pdc_id });

    yield put({ type: SECTORS_SET_ALL, sectorsList: _.cloneDeep(sectorsList) });
    const currentClient = yield select(currentClientSelector);
    yield call(removePDCApi, state, action.sector_id, action.pdc_id,  currentClient.id);
  } catch (e) {
    console.log(e.message);
  }
}

function* watchGetSectorsList() {
  yield takeLatest(SECTORS_SET_PAGINATION, getSectorsList);
}

function* watchGetManagerUsersList() {
  yield takeLatest(SECTORS_GET_MANAGER_USERS_LIST, getManagerUsersList);
}

function* watchGetPDCS() {
  yield takeLatest(SECTORS_GET_PDCS, getPDCS);
}

function* watchAddPDC() {
  yield takeLatest(SECTORS_ADD_PDC, addPDC);
}

function* watchRemovePDC() {
  yield takeLatest(SECTORS_REMOVE_PDC, removePDC);
}

export default function* root() {
  yield all([
    fork(watchGetSectorsList),
    fork(watchGetManagerUsersList),
    fork(watchGetPDCS),
    fork(watchAddPDC),
    fork(watchRemovePDC)
  ]);
}



// WEBPACK FOOTER //
// src/redux/sagas/sectorsSagas.js